export default function Text2Give() {
  return (
    <section>
      <h2 className="h3 mb-2">Text2Give</h2>
      <p>Text2Give details</p>
    </section>
  )
}
